import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { createColumnHelper } from '@tanstack/react-table';

import { DataGrid } from 'src/common/DataGrid';
import {
  MomentmBrokerAuthRead,
  useBrokersMomentmBrokerAuthListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { MomentmManageCell } from './MomentmCells/ManageCell';
import { OrganizationCell } from './MomentmCells/OrganizationCell';
import { PayerCell } from './MomentmCells/PayerCell';
import { MomentmSettingsFormModal } from './MomentmSettingsFormModal';

const columnHelper = createColumnHelper<MomentmBrokerAuthRead>();

const columns = [
  columnHelper.accessor('username', {
    header: 'Username',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('broker_name', {
    header: 'Broker Name',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('payer', {
    header: 'Payer',
    meta: {
      enableHeaderMenu: false,
    },
    cell: ({ row }) => <PayerCell payer={row.original.payer} />,
  }),
  columnHelper.accessor('api_url', {
    header: 'API URL',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('organization', {
    header: 'Organization',
    meta: {
      enableHeaderMenu: false,
    },
    cell: ({ row }) => (
      <OrganizationCell organizationId={row.original.organization} />
    ),
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => <MomentmManageCell setting={row.original} />,
    meta: {
      enableHeaderMenu: false,
    },
  }),
];

export function MomentmSettingsDataGrid() {
  const { data, isLoading } = useBrokersMomentmBrokerAuthListQuery({});

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <DataGrid<MomentmBrokerAuthRead>
        tableId="momentm-settings-data-grid"
        columns={columns}
        data={data?.results ?? []}
        totalCount={data?.count ?? 0}
      />
      <MomentmSettingsFormModal />
    </>
  );
}
